/**
 * Theme constants for consistent styling across the app
 */

export const THEME = {
  colors: {
    primary: "#0d6cf2",
    gold: "#D4AF37",
    neonPink: "#ff00ff",
    neonCyan: "#22d3ee",
    background: {
      light: "#f5f7f8",
      dark: "#101722",
      darker: "#05080c",
    },
    surface: {
      light: "#ffffff",
      dark: "#1a2433",
      highlight: "#1E293B",
    },
  },
};

export const SOCIAL_LINKS = {
  instagram: "https://instagram.com/matisaislive",
  youtube: "https://www.youtube.com/@matisaislive",
  whatsapp: "https://wa.me/message/BDUVQZ6MXENFB1",
};

export const CONTACT = {
  email: "matisaislive@gmail.com",
};

export const NAVIGATION = [
  { label: "Home", href: "/" },
  { label: "What I Do", href: "/shows" },
  { label: "Videos", href: "/videos" },
  { label: "Photos", href: "/photos" },
  { label: "Matisa Records", href: "/recordings" },
  { label: "Live This Month", href: "/live" },
  { label: "Our Clientele", href: "/clientele" },
  { label: "Book a Show", href: "/enquiry" },
];
